import { authorizedAction } from 'api'
import { ErrorProp } from './'
import { UserType } from 'types'
import { TEACHER, TEACHER_DC } from '../constants'

export type ReactivateTMATTResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type ReactivateTMATTProps = {
  userId?: string
  userType?: UserType
}

export async function reactivateTMATT({
  userId,
  userType,
}: ReactivateTMATTProps): Promise<ReactivateTMATTResponseProps> {
  try {
    if (userType !== TEACHER && userType !== TEACHER_DC) {
      throw new Error('Invalid user type')
    }
    const action =
      userType === TEACHER
        ? 'Teacher.LMSReactivate'
        : 'Teacher.LMSReactivateRefresher'

    const response = await authorizedAction({
      action: action,
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as ReactivateTMATTResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
